import React from 'react';
import { CSSProperties } from 'react';

import { ReactComponent as AmplifyLogo } from '../../../assets/amplify-colors.svg';
import { FE_VERSION } from '../../../consts/version';

const AppLoader: React.FC = () => {
  const containerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: '#000', // Black background
    zIndex: 9999,
    flexDirection: 'column',
  };

  const logoStyle: CSSProperties = {
    width: '160px',
    height: '137px',
    marginBottom: '20px',
  };

  const textStyle: CSSProperties = {
    fontSize: '30px', // Adjust size as needed
    color: '#A1A1A1', // Grey color for "upd. V2"
  };

  return (
    <div style={containerStyle}>
      <AmplifyLogo aria-label="Amplify" style={logoStyle} />
      <div style={textStyle}>version {FE_VERSION}</div>
    </div>
  );
};

export default AppLoader;
